/* istanbul ignore file */



import React from 'react';

















export const SocialAuthButtonListContext = React.createContext({
  onAuthSuccess: () => {},
  onAuthError: () => {}
});